import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Typography";
import ImageElement from "components/atoms/ImageElement";
import Lottie from 'react-lottie';
import {useStyles} from "./styles"

import {DeleteSuccessIconLightJSON} from "svgs/light"

interface DeleteSuccessProps {
  deleteModeText?: string 
  mobile?:string | number | undefined,
}


const LottieAnimation = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true, // Boolean to control whether the animation should start playing automatically
    animationData: DeleteSuccessIconLightJSON,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return <Lottie options={defaultOptions} height={80} width={80} />;
};

export default function  DeleteSuccess({
  deleteModeText,
  mobile="",
}:DeleteSuccessProps){
  const classes = useStyles();

    return (
      <div
      style={{
        margin:"auto",
        marginTop:"10vh",
        width:'90%',
        maxWidth:"600px"
      }}
      >
        <div
          style={{
            display: "flex",
            justifyContent:"center",
            alignItems: "center",
            paddingBottom: "4%",
          }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ImageElement
              src="/assets/images/logo.png"
              style={{
                height: "90%",
                width: "12%",
                paddingRight: "2%",
                textAlign: "center",
              }}
            />
            <Typography
              component="h1"
              variant="h5"
              style={{
                textAlign: "center",

                fontSize: "2vw",
              }}
            >
              {" "}
              AMT{" "}
            </Typography>
          </Box>
        </div>

        <div
          style={{
            background: "#F5F5F5",
            padding: "40px",
            borderRadius: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >

          <LottieAnimation/>


          <Typography
            component="h1"
            variant="h4"
            style={{
              textAlign: "center",
              // fontSize: "1.7vw",
              color: "#16151C",
              fontWeight: 500,
              marginTop: "20px",
              marginBottom: "15px",
            }}
          >
            Your account has been successfully {deleteModeText}.
          </Typography>

          <Typography
            component="p"
            variant="body1"
            style={{
              color: "rgba(22, 21, 28, 0.60)",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
        The account associated with this phone number 
        {" "}
        <Typography
        // variant="body0"
        style={{
          color:"rgba(22, 21, 28, 0.60)",
          fontWeight:700,
          fontSize:"inherit",
          lineHeight:"inherit",
          display:"inline"
        }}>
          “{mobile}” 
          </Typography>
          {" "}
        
        
        has been {deleteModeText}
          </Typography>
        </div>
      </div>
    );
  };